import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";
import { Users, FileText, Newspaper, Calendar, Inbox, UserCog, ImageIcon } from "lucide-react";

const CARDS = [
  { key: "members", label: "Socios", icon: Users, to: "/admin/members" },
  { key: "news", label: "Noticias", icon: Newspaper, to: "/admin/news" },
  { key: "events", label: "Eventos", icon: Calendar, to: "/admin/events" },
  { key: "pages", label: "Páginas", icon: FileText, to: "/admin/pages" },
  { key: "submissions", label: "Mensajes", icon: Inbox, to: "/admin/submissions" },
  { key: "users", label: "Usuarios", icon: UserCog, to: "/admin/users" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="cms-dashboard">
      <h1 className="text-3xl font-semibold text-[#0F2040] mb-2">Bienvenido</h1>
      <p className="text-gray-600 mb-10">Panel de gestión de contenidos del sitio CECIT.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-10">
        {CARDS.map((c) => (
          <Link
            key={c.key}
            to={c.to}
            data-testid={`stat-card-${c.key}`}
            className="bg-white p-6 border border-gray-200 hover:border-[#0F2040] hover:shadow-md transition-all group"
          >
            <c.icon className="w-5 h-5 text-[#C8102E] mb-3" strokeWidth={1.5} />
            <p className="text-3xl font-semibold text-[#0F2040]">{stats?.[c.key] ?? "–"}</p>
            <p className="text-xs uppercase tracking-wider text-gray-500 mt-1">{c.label}</p>
          </Link>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white p-7 border border-gray-200">
          <h2 className="font-semibold text-[#0F2040] mb-4">Acciones rápidas</h2>
          <div className="space-y-2">
            <Link to="/admin/hero-slides" className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 text-sm text-gray-700">
              <ImageIcon className="w-4 h-4 text-[#C8102E]" /> Editar hero de la portada
            </Link>
            <Link to="/admin/news" className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 text-sm text-gray-700">
              <Newspaper className="w-4 h-4 text-[#C8102E]" /> Publicar una noticia
            </Link>
            <Link to="/admin/events" className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 text-sm text-gray-700">
              <Calendar className="w-4 h-4 text-[#C8102E]" /> Crear un evento
            </Link>
            <Link to="/admin/settings" className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 text-sm text-gray-700">
              <FileText className="w-4 h-4 text-[#C8102E]" /> Ajustar logos del footer
            </Link>
          </div>
        </div>

        <div className="bg-white p-7 border border-gray-200">
          <h2 className="font-semibold text-[#0F2040] mb-4">Mensajes pendientes</h2>
          <div className="text-center py-8">
            <p className="text-5xl font-serif text-[#0F2040]">{stats?.submissions_unread ?? 0}</p>
            <p className="text-xs uppercase tracking-wider text-gray-500 mt-2">no leídos</p>
            <Link to="/admin/submissions" className="inline-block mt-5 text-sm text-[#C8102E] hover:underline">
              Ver bandeja de entrada →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
